import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('CONTACTS_ORGANIZATION')